<template>
  <div class="home-content">
      <div class="cover-image">
        <b-img v-bind:src="coverImage" fluid></b-img>
        <img v-if="liveDj" src="./assets/img/emp-tweaked-lg.png" style="position:absolute; top:0px; left:0px; height:100px; width:auto; opacity:0.75;">
      </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        djs: {
            Archives: {
                UserName: null,
                DisplayName: "EMP Archives",
                UseCustomBackground: false,
                UseCustomCoverImage: false
            },
            Lerk: {
                UserName: "Lerk",
                DisplayName: "Lerk Hern",
                UseCustomBackground: true,
                UseCustomCoverImage: true
            }
        },
        liveDj:null,
        rightPanel: "home"
      }
    },
    computed: {
      coverImage () {
        if (this.liveDj && this.liveDj.UseCustomCoverImage) {
          return require('./assets/img/djs/' + this.liveDj.UserName.toLowerCase() + '.jpg');
        }
        return require('./assets/img/emp-tweaked-lg.png');
      }
    },
    methods: {
      switchPanel: function(panel) {
        this.rightPanel = panel;
      }
    }
  }
</script>

<style>
.home-content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cover-image {
  max-width: 50%;
}
</style>




// WEBPACK FOOTER //
// src/Home.vue